import '@emotion/react';

var CC_BLUE = 'rgb(34, 112, 184)';
var CC_BLUE_DARKER = 'rgb(32,112,150)';
var WHITE = '#fff';
var BLACK = '#000';
var LIGHT_GREY = '#E7E7E7';
var LIGTHER_GREY = '#f8f8f8';
var INNER_SHADOW = 'rgba(0,0,0,0.05)';
var TEXT = '#20292E';
var RED = '#FF2626';
var defaultTheme = {
  colorScheme: 'dark',
  mq: {},
  colors: {
    bgColor: WHITE,
    background: WHITE,
    border: LIGHT_GREY,
    highlight: CC_BLUE_DARKER,
    menuHighlight: BLACK,
    primary: CC_BLUE,
    secondary: WHITE,
    text: TEXT,
    buttonText: WHITE,
    lightestBackground: WHITE,
    lightBackground: LIGTHER_GREY,
    innerShadow: INNER_SHADOW,
    error: RED,
    appNavBackground: '#D9E0E4',
    appNavItemBackground: '#E8F6F7'
  },
  fonts: {
    fontFamily: 'Helvetica, Arial, sans-serif',
    fontFamilyCondensed: 'Helvetica, Arial, sans-serif',
    fontSize: '1rem',
    fontSizeSmall: '0.75rem',
    fontSizeForms: '1.25rem',
    lineHeight: '1.25',
    headingSizes: {
      h1: '1,5rem',
      h2: '1.25rem',
      h3: '1rem'
    }
  },
  atoms: {},
  molecules: {},
  organisms: {}
};

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function () {};
      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

//TODO

/* eslint-disable */
// @ts-ignore

var mCss = function mCss(type, styling, state) {
  console.warn('⚠️ mCss is deprecated, use generateCss instead');
  return {};
};
var generateCss = function generateCss(m) {
  return buildCss(m);
};
var generateClassName = function generateClassName(className, styling, state) {
  return "cue-".concat(className, " ").concat(styling ? "cue-".concat(className, "-").concat(styling) : '', " ").concat(state ? "cue-".concat(className, "-").concat(state) : '');
};
var buildCss = function buildCss(mcss) {
  var _parsedCss$states;
  var theme = mcss.theme,
    type = mcss.type,
    key = mcss.styling,
    state = mcss.state;
  var base = getPropertyByPath(theme, type);

  // TODO
  // @ts-ignore
  var styling = base === null || base === void 0 ? void 0 : base[key || 'default'];
  // TODO
  // @ts-ignore
  var defaultStyling = base === null || base === void 0 ? void 0 : base["default"];
  if (!styling) {
    return defaultStyling || {};
  }
  // TODO
  // @ts-ignore
  if (!key) return base;
  var parsedCss = deepMCss(base, 'default', key);
  if (!state) return parsedCss;
  return _objectSpread2(_objectSpread2({}, parsedCss), (parsedCss === null || parsedCss === void 0 || (_parsedCss$states = parsedCss.states) === null || _parsedCss$states === void 0 ? void 0 : _parsedCss$states[state]) || {});
};
var deepMCss = function deepMCss(type, base, add) {
  var addStyles = type[add];
  var ret = [type[base]];
  if (addStyles !== null && addStyles !== void 0 && addStyles.extend) {
    if (Array.isArray(addStyles.extend)) {
      addStyles.extend.forEach(function (e) {
        return ret.push(type[e]);
      });
    } else {
      ret.push(type[addStyles === null || addStyles === void 0 ? void 0 : addStyles.extend]);
    }
  }
  ret.push(addStyles);
  var mergedObject = ret.reduce(function (acc, curr) {
    // Merge the current object properties into the accumulator object
    return _objectSpread2(_objectSpread2({}, acc), curr);
  }, {});
  return mergedObject;
};
var getPropertyByPath = function getPropertyByPath(obj, path) {
  var properties = path.split('.');
  var value = obj;
  var _iterator = _createForOfIteratorHelper(properties),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var property = _step.value;
      if (value && Object.prototype.hasOwnProperty.call(value, property)) {
        // TODO
        // @ts-ignore
        value = value[property];
      } else {
        return undefined;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return value;
};

export { defaultTheme, generateClassName, generateCss, mCss };
